import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e772a320&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e772a320",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e772a320')) {
      api.createRecord('e772a320', component.options)
    } else {
      api.reload('e772a320', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e772a320&scoped=true", function () {
      api.rerender('e772a320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Account/index.vue"
export default component.exports